import { useNavigate, useParams, useLocation } from "react-router-dom";
import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import ReactDOM from 'react-dom';
import Quiz from '../components/pages/tutorial_page/Quiz.js';

import Progress from '../components/pages/tutorial_page/Progress.js';
import ProgressAccordion from '../components/pages/tutorial_page/ProgressAccordion.js';
import Error from './Error.js';
import Loading from './Loading.js';

import GetData from "../hooks/getData.js";
import useIsMobile from "../hooks/useIsMobile.js";
import useTallyEmbed from "../hooks/useTallyEmbed.js";

import './Course.css';
import HighlightCode from "../HighlightCode.js";

const parse = require('html-react-parser');
const DOMPurify = require('dompurify');

function Course() {
    const { state } = useLocation();
    const navigate = useNavigate();
    const params = useParams();
    const level_number = params.levelNumber;
    const step_number = params.stepNumber;
    const step_index = step_number - 1;
    const course_type = params.course;
    const [error, setError] = useState(false);

    // Map course slugs to display names
    const COURSE_NAMES = {
        "python": "Python",
        "python-legacy": "Python Legacy",
        "web-development": "Web Development",
        "apis-with-python": "APIs with Python"
    };
    
    // Fallback: convert slug to readable name
    const courseDisplayName = COURSE_NAMES[course_type] || course_type.replace(/-/g, ' ').replace(/\b\w/g, c => c.toUpperCase());

    const { all_steps, all_titles, loading, all_quizzes } = GetData(state, level_number, course_type);
        useEffect(() => {
        if (
            (!loading && all_steps.length === 0) ||
            step_index < 0 ||
            (all_steps.length !== 0 && step_index >= all_steps.length)
        ) {
            setError(true);
        } else {
            setError(false);
        }
    }, [loading, all_steps, step_index]);

    const mobile = useIsMobile();
    useTallyEmbed();

    // sanitize current step content and title
    const current_title = all_titles[step_index];
    const current_step_content = all_steps[step_index];
    const clean_current_title = DOMPurify.sanitize(current_title);
    const clean_step_content = DOMPurify.sanitize(current_step_content, {
        ADD_TAGS: ["iframe"],
        ADD_ATTR: ['target', 'allow', 'allowfullscreen', 'frameborder', 'scrolling']
    });

    useEffect(() => {
        setTimeout(() => {
            HighlightCode();
        }, 100); // small delay to ensure DOM updates first
    }, [step_index, clean_current_title]);

    // determine next step or finish
    const next_page = step_index + 2;
    const has_next_page = next_page <= all_titles.length;
    const button_info = has_next_page
        ? [`/${course_type}/level/${level_number}/step/${next_page}`, "Next"]
        : [`/${course_type}/level/${level_number}/finish`, "Finish!"];

    if (loading) return <Loading />;
    if (error) return <Error />;

    return (
        <div>
            <Helmet>
                <title>{current_title} | {courseDisplayName} Level {level_number} | Mission Encodeable</title>
            </Helmet>

            <div className="Header-box">
                <h1 className="Header-title darkgreen">{courseDisplayName} Level {level_number}</h1>
            </div>

            <div className="course_content">
                {mobile
                    ? <ProgressAccordion all_titles={all_titles} current_step={step_index + 1} />
                    : <Progress progress_titles={all_titles} current_step={step_index + 1} />
                }

                <div className="shadow_box">
                    <h2>{clean_current_title}</h2>
                    {all_quizzes[step_index] ? (
                       <Quiz quizData={JSON.parse(all_quizzes[step_index])} title={current_title}/>
                     ) : null}
                    {parse(`${clean_step_content}`)}
                    <button
                        onClick={() => {
                            navigate(button_info[0], { state: { courseSteps: all_steps, courseTitles: all_titles, courseQuizzes: all_quizzes } });
                        }}
                        className="btn_orange_fill"
                    >
                        {button_info[1]}
                    </button>
                </div>
            </div>
        </div>
    );
}

export default Course;